"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const ContentGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "CONTENT-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 .25C5.51.25.25 5.51.25 12S5.51 23.75 12 23.75 23.75 18.49 23.75 12 18.49.25 12 .25m0 1c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12 6.063 1.25 12 1.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 13a.5.5 0 0 1 .5.5 7.25 7.25 0 0 1-14.5 0 .5.5 0 1 1 1 0 6.25 6.25 0 1 0 12.5 0 .5.5 0 0 1 .5-.5m-.09-5.221a.5.5 0 0 1 .304.638 2.75 2.75 0 0 1-5.185 0 .5.5 0 1 1 .942-.334 1.75 1.75 0 0 0 3.3 0 .5.5 0 0 1 .639-.304m-8.743 0a.5.5 0 0 1 .304.638 2.75 2.75 0 0 1-5.185 0 .5.5 0 1 1 .942-.334 1.75 1.75 0 0 0 3.3 0 .5.5 0 0 1 .639-.304"
  })));
};
ContentGraphicIcon.displayName = "ContentGraphicIcon";
ContentGraphicIcon.iconName = "Content";
export default ContentGraphicIcon;